<template lang="pug">
.main__view
  .nav__box.white(v-if="!isArena")
    navigation(v-if="!isAfishaDomain")
    navigation-afisha(v-if="isAfishaDomain")
    //-cabinet-services-line.padding(:links="links")
  .container.row
      app-aside(:profile="profile")
      .line-sep
      .view
        transition(name="fade" mode="out-in")
          router-view
  .page__footer(v-if="!isArena")
    // app-footer
    hublPreFooterCab.preFooterCab
    guru-footer

  //- .page__view
    navigation
    .line-1px-f0

    //- app-header
    .page__header
      .row
        .title {{$t('common.userAccount')}}
    .content
      app-aside(:profile="profile")
      .view
        transition(name="fade" mode="out-in")
          router-view

  wizard
  popup-login(v-if="!isLogged && !isAfishaDomain", res="cabinet")
  popup-login-afisha(v-if="!isLogged && isAfishaDomain", res="cabinet")

  client-only
    Widget(v-if="showWidget",
      :sid="idWidget", :seid="seidWidget", :iid="iidWidget",
      @close="closeWidget")
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
// import API from '@/api/api';
import Wizard from 'components@/wizard';
import popupLogin from 'components@/popups/login';
import popupLoginAfisha from 'components@/popups/loginNew';
import guruFooter from 'components@/footerCab';
import hublPreFooterCab from 'components@/hublPreFooterCab';
// import AppHeader from '@/components/Header.vue';
// import AppFooter from '@/components/Footer.vue';
// import Navigation from '@/components/Navigation.vue';
import Navigation from 'components@/navCab';
import NavigationAfisha from 'components@/navCabAfisha';
import breadcrumbs from '@/components/Breadcrumbs.vue';
import AppAside from '@/components/Aside.vue';
// import popupLogin from '@/components/popups/login.vue';

import CabinetServicesLine from '@/components/services-line.vue';
import Widget from '@/components/Widget.vue';
import favicon from './favicons/favicon.png';
import faviconGe from './favicons/faviconV2.png';

export default {
  components: {
    CabinetServicesLine,
    //
    // AppHeader,
    Navigation,
    NavigationAfisha,
    // AppFooter,
    breadcrumbs,
    AppAside,
    popupLogin,
    popupLoginAfisha,
    Wizard,
    guruFooter,
    hublPreFooterCab,
    Widget,
  },
  data() {
    return {
      links: [{
        url: 'https://24afisha.by',
        name: 'афиша',
      }, /* {
        url: 'https://24trip.by',
        name: 'trip',
      }, */ {
        url: 'https://24afisha.by/ru/minsk/objects',
        name: 'места',
      }, {
        url: 'https://24skidki.by',
        name: 'скидки',
      }, {
        url: 'https://24guru.by',
        name: 'новости',
      }, {
        url: 'https://24menu.by',
        name: 'еда',
      }, {
        url: 'https://24afisha.by/ru/minsk/videos/packages',
        name: 'online TV',
      }],

      cabinet: this.getCabinet,
      profile: null,
      bg: '',
      bgColor: '#efefef',
      isArena: false,
      isAfishaDomain: true,
    };
  },
  watch: {
    isLogged(val) {
      if (val) {
        this.$store.dispatch('cabinet');
      }
    },
    getCabinet(val) {
      this.cabinet = val;
      this.profile = val.profile;
    },
    getLayout(val) {
      if (val.branding) {
        this.bg = `url(${val.branding.image})`;
        this.bgColor = val.branding.color;

        // const bod = document.querySelector('body');
        // bod.style.backgroundColor = this.bgColor;
        // bod.style.backgroundImage = this.bg;
      }
    },
  },
  computed: {
    ...mapGetters({
      isLogged: 'user/isLogged',
      getCabinet: 'getCabinet',
      getLayout: 'getLayout',
      showWidget: 'open',
      idWidget: 'id',
      seidWidget: 'seid',
      iidWidget: 'iid',
    }),
    bc: () => [{
      name: 'Личный кабинет',
      link: '#',
    }],
  },
  async mounted() {
    if (window.location.href.match(/guru.ge/)) this.isAfishaDomain = false;

    // Устанавливаем фавикон в зависимости от сайта
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link'); // eslint-disable-line
    link.type = 'image/x-icon'; // eslint-disable-line
    link.rel = 'shortcut icon'; // eslint-disable-line
    link.href = this.isAfishaDomain ? favicon : faviconGe; // eslint-disable-line
    document.getElementsByTagName('head')[0].appendChild(link); // eslint-disable-line

    if (window.location.href.match(/guru.ge/) || window.location.href.match(/localhost/)) {
      const locale = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
      if (document.getElementsByTagName('html')[0].getAttribute('lang') !== localStorage.getItem('lang')) {
        document.getElementsByTagName('html')[0].setAttribute('lang', locale === 'ge' ? 'ka' : locale);
      }
    }

    // Для преодоления рекапчи на тесте
    // localStorage.setItem('_grecaptcha', '09ACgiStyQ9W-VdAvQWOsWsy2NEAS2wmWNq9d9UXw6zKjvTC9e5pJqTddpyTo9ex0P6jYIniLBWm8r51EkY8Byst7qG0u2ozTooiSdTw');
    // this.$cookies.set('token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3dlYmdhdGUuYXJjb20ub2YuYnkvYXBpL3YzL2F1dGgiLCJpYXQiOjE3MzE2ODIxNzUsImV4cCI6MTczNDEwMTM3NSwibmJmIjoxNzMxNjgyMTc1LCJqdGkiOiJlcGF6dDBTbjhxRkxaQ3QxIiwic3ViIjo1OTI2LCJwcnYiOiIwMGM3NTVjYTVhM2E1ZGU3MmU1NjlkY2NlYWI1MGE5YjEwYjlhNTkxIn0.nCnqVKSQZRayw24wEXH1erqWj172Hi42hZbu3dgfgAc', '1y');

    // localStorage.setItem('_grecaptcha', '09ACgiStyQ9W-VdAvQWOsWsy2NEAS2wmWNq9d9UXw6zKjvTC9e5pJqTddpyTo9ex0P6jYIniLBWm8r51EkY8Byst7qG0u2ozTooiSdTw');
    // this.$cookies.set('token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3dlYmdhdGUyLjI0Z3VydS5ieS9hcGkvdjMvYXV0aCIsImlhdCI6MTcyNjY0MzkxNSwiZXhwIjoxNzI5MDYzMTE1LCJuYmYiOjE3MjY2NDM5MTUsImp0aSI6IjV0MTViZzBCYk9meDFqcW0iLCJzdWIiOjQyNTI1LCJwcnYiOiIwMGM3NTVjYTVhM2E1ZGU3MmU1NjlkY2NlYWI1MGE5YjEwYjlhNTkxIn0.bleTPTKsfUsVGqTUY9ARtoU9UU1QZMAKjnjtz12bQJA', '1y');

    if (window.location.href.match(/minskarena/)) this.isArena = true;
    if (window.localStorage.getItem('lang')) {
      this.$i18n.locale = window.localStorage.getItem('lang');
      this.$moment.locale(window.localStorage.getItem('lang'));
    } else {
      if (window.location.host.includes('guru.ge')) { // eslint-disable-line
        this.$i18n.locale = 'ge';
        this.$moment.locale('ge');
      } else {
        this.$i18n.locale = 'ru';
        this.$moment.locale('ru');
      }
    }
    document.title = `${window.location.host.includes('guru.ge') ? 'guru.ge' : '24afisha'} - ${this.$t('cabinet')}`;

    const description = `${window.location.host.includes('guru.ge') ? '' : 'Единый билетный кабинет для 24afisha.by, relax.by, afisha.me, 024.by'}`;
    const metaDescription = document.querySelector('meta[name="description"]');
    metaDescription.setAttribute('content', description);

    this.$store.dispatch('layout');
    this.$store.dispatch('user/isLogged');

    // const bod = document.querySelector('body');
    // bod.style.backgroundColor = this.bgColor;
    // bod.style.backgroundImage = this.bg;

    if (this.logged) {
      this.$store.dispatch('cabinet');
    }

    // window.addEventListener('message', (event) => {
    //   // Проверка origin отправителя
    //   const whiteListDomains = ['https://mobile.arcom.of.by', 'https://24afisha.arcom.of.by', 'https://mobile.24afisha.by', 'https://24afisha.by', 'https://guru.ge'];

    //   if (event.data.action === 'setUserInfo') {
    //     if (!whiteListDomains.includes(event.origin)) {
    //       console.warn('Сообщение от неизвестного источника:', event.origin);
    //       return;
    //     }
    //     if (event.data.username && event.data.token && event.data.avatar) {
    //       this.$cookies.set('username', `base64${window.btoa(event.data.username)}`, '360d', '', null, true, 'None');
    //       this.$cookies.set('token', event.data.token, '360d', '', null, true, 'None');
    //       this.$cookies.set('avatar', `base64${window.btoa(event.data.avatar)}`, '360d', '', null, true, 'None');
    //     }
    //   }
    // });
  },
  methods: {
    ...mapActions({
      closeWidget: 'close',
    }),
    isLogin() {
      setTimeout(() => { // timeout but need small wait iframe init
        if (Object.prototype.hasOwnProperty.call(this.$root, 'wizard') && this.$root.wizard) {
          this.$root.wizard.isLogin((result) => {
            if (result && result.token && result.username && result.avatar) {
              this.$store.dispatch('user/isLogged', window);
            } else {
              this.$store.dispatch('user/logout');
            }
          });
        }
      }, 2000); // 2 seconds for init iframe
    },
  },
};
</script>

<style lang="scss">
.tab-page-container {
  position: relative;
  min-height: 450px;
  width: 100%;
}

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;531;600;700;800;900&display=swap');
/* system start */
%stretch-stretch {
  justify-content: stretch;
  align-items: stretch;
}
.main__view {
  @extend .flex, .col, %stretch-stretch;
  width: 100%;
  height: 100%;
  min-height: 100%;
  position: relative;
}
.container {
  max-width: 1170px;
  min-width: 300px;
      width: 100%;

  margin-left: auto;
  margin-right: auto;
}

.row, .col, .flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}

.row {
  flex-direction: row;
}
.col {
  flex-direction: column;
}

.visible__layout {
  width: 100%;
  margin: 70px 0 0 60px;
}

.h1-title {
  font-family: Inter;
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: rgb(0, 0, 0);
}
.h2-title {
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: rgb(0, 0, 0);
}

.info-text {
  font-family: Inter;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgb(153, 153, 153);
}

.support-text {
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: rgb(136, 136, 136);
}

.c-loop-icon {
  margin-right: 10px;
  vertical-align: middle;
}

.taber-enter-active, .taber-leave-active {
  transition: opacity .3s ease;
}
.taber-enter, .taber-leave-to
/* .component-fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.text {
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: rgb(0, 0, 0);
}

.line-sep {
  display: block;
  min-width: 1px;
  min-width: 1px;
  width: 1px;
  height: 100%;
  background-color: rgb(232, 232, 232);
}
/* system end */

// .container {
//   min-height: auto;
// }

div.page__view {
  margin-top: 0;
  margin-bottom: 0;
}
.content {
  display: flex;
}
.page__header{
  margin: 1.75rem 1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.page__footer{
  max-width: 1170px;
  min-width: 1170px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  // margin: 1.25rem;
}
.preFooterCab {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}

.nav__box.white {
  max-width: 1170px;
  min-width: 300px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.padding {
  padding: 1.875rem 1.25rem;
}
.grecaptcha-badge {
  visibility: hidden;
}
</style>
